/**
 * Annotation line styling.
 */
export enum LineStyle {
  /** Solid. */
  Solid = 'solid',
  /** Dashed. */
  Dashed = 'dashed',
  /** Dotted. */
  Dotted = 'dotted',
}
/**
 * Annotation line cap styling.
 */
export enum CapStyle {
  /** Butt. */
  Butt = 'butt',
  /** Projecting. */
  Projecting = 'projecting',
  /** Round. */
  Round = 'round',
}

/**
 * Annotation line ending style.
 */
export enum EndCapStyle {
  /** End of line has no particular style. */
  None = 'None',
  /** Line ends with a outward filled pointing arrow. */
  FilledArrow = 'FilledArrow',
  /** Line ends with a outward filled ellipse. */
  FilledEllipse = 'FilledEllipse',
  /** Line ends with an outward diamond. */
  Diamond = 'Diamond',
  /** Line ends with an outward pointing arrow. */
  Arrow = 'Arrow',
}

/** End Cap height. */
export enum EndCapHeight {
  /** Long. */
  Long = 25,
  /** Short. */
  Short = 5,
  /** Medium. */
  Medium = 15,
}

/** End cap width. */
export enum EndCapWidth {
  /** Wide. */
  Wide = 25,
  /** Narrow. */
  Narrow = 5,
  /** Medium. */
  Medium = 15,
}
